import { RouteComponentProps, useHistory } from "react-router-dom";
import { getPath } from "common/routing";
import FullPageBackgroundWithLogo from "../../Common/FullPageBackgroundWithLogo";
import ResetForm, { ResetFormURLParams } from "./ResetForm";

export default (props: RouteComponentProps<ResetFormURLParams>) => {
  const history = useHistory();
  const onLoginClick = () => {
    history.push(getPath("login"));
  };

  return (
    <FullPageBackgroundWithLogo>
      <ResetForm {...props} onLoginClick={onLoginClick} />
    </FullPageBackgroundWithLogo>
  );
};
